// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","199":"admin-users","253":"admin-lists","317":"admin-words","690":"items","700":"home-login","831":"lists"}[chunkId] + "." + {"177":"002ffa67","199":"964db841","253":"964db841","317":"c299c951","690":"f5799374","700":"85fdf492","831":"aea55367"}[chunkId] + ".css";
};